import { Theme, createStyles } from '@material-ui/core';
const styles = (theme: Theme) => createStyles({
  businessTypeRow: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '18px',
    '& .labelBox': {
      marginLeft: 0,
      marginRight: '28px',
      '&>span': {  
        padding: '0 7px 0 0',
        '&>span>svg': {
          fontSize: '20px',
          fill: '#CACACA',
          width: '20px',
          height: '20px',
          border: 'solid 1px #cacaca',
          borderRadius: '2px',
          '&>path': {
            opacity: 0,
          }
        },
        '&.clickedCheckbox>span>svg': {
          backgroundColor: '#1d7dea',
          borderColor: '#1d7dea',
          backgroundImage: 'url(/assets/svg/course-plan-request/checkmark.svg)',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'auto',
        }, 
        '&:last-child': {
          fontSize: '16px',
          fontWeight: 400,
          color: '#666666',
        }
      }
    }
    
  },
  labelText: {
    margin: '0 30px 0 0',
    width: 'auto',
    justifyContent:'flex-start',
    alignItems:'center'
  },
  pointer:{
    cursor: 'pointer',    
  },
  blueText: {
    color: '#1d7dea !important',
    fontWeight: 500,
    lineHeight: '1.5'
  },
  redColor: {
    color: 'red !important'
  },
  popupIcon:{
    '& img':{
      width: '80px',
      height: 'auto',
      verticalAlign: '-6px'
    }
  },
  txtCenter:{
    textAlign: 'center'
  },
  tabPanel: {
    marginTop: 20,
    marginBottom: 12, 
    // background: 'rgb(255 255 0)',
    position: 'absolute',
    right: 0,
    left: 0,
    top: '100%',
    '& .subPanel': {
      color: 'rgb(153 153 153)',
      padding: "0",
      fontSize:16,
      fontWeight:600,
      cursor: 'pointer',
      '& > *': {
        cursor: 'pointer',
      }
    },   
    '& .activeTab':{
      color: '#1D7DEA'
    }, 
  },
    test: {
        color:'red'
    },

    paper: {
      width: "calc(100% - 0px)",
      height: "100%",
      // backgroundColor: "#fff",
      // boxShadow: theme.shadows[5],
      borderRadius: 4,
      outline: "#fff",
      marginLeft: "auto",
    },
    modal: {
      display: "flex",
      padding: 0,
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 4,
      margin: "0px 0px 12px 83px",
      zIndex: 2
    },
    modalHeader: {
      boxShadow: "none",
      backgroundColor: '#fff'
    },
    cardContentStyle:{
      maxHeight: "calc(100vh - 130px)",
      overflow: "auto",
      minHeight: "calc(100vh - 130px)",
      margin: '0px 0px 0px 8px',
    },
    // Create combo course
    cardContentStyle1:{
      background: '#fff',
      marginBottom: 100,
  },
  cardContainer1: {
    // margin: '-16px -10px',
    border: "1px solid #E4E4E4",
    '& $label':{
        fontWeight: 600,
        display: "flex",
        justifyContent: "space-between",
        marginRight: 0,
        margin: 0,
    }
  },
  // End
    cardHeading:{
        // fontWeight:600,
        fontSize:20,
        color: '#333',
        margin: '10px 0 15px 0',
        '& span':{
            color: '#f50057'
          }
    },
    cardContainer: {
        // margin: '-16px -10px',
        backgroundColor: 'rgb(251 251 251)',
        // minHeight: '100vh',
        border: "1px solid #E4E4E4",
        '& $label':{
            fontWeight: 600,
            display: "flex",
            justifyContent: "space-between",
            marginRight: 0,
        }
      },
      smallInfo:{
        fontSize: 12,
        lineHeight: '16px',
        color: '#666'
      },
      inputLable:{
        fontWeight: 600,
        fontSize:16,
        lineHeight: '22px',
        color: '#666',
        marginBottom: 10,
        marginTop: 5,
        display: 'inline-block',
        textTransform: 'capitalize',
        '&>span':{
          fontSize: 13,
        },
      },
      mb0:{
        marginBottom: 0
      },
      mt30:{
        marginTop: 20,
      },
      mt8:{
        marginTop: 8,
      },
      mr10: {
        marginRight: 10,
      },
      ml10: {
        marginLeft: 10
      },
      fullWidthSelect:{
        '&>div':{
          width: '100%'
        }
      },
      updateLabel:{
          marginLeft: 0,
          display: "flex",
          fontWeight: 600,
          marginRight: 0,
          justifyContent: "space-between",
          alignItems: "center",
          margin: '0 0 5px 0',
          background: '#F4F4F4',
          borderRadius: '4px',
          padding: '0 11px',
        '&>span':{
            // fontWeight: 600,
            fontSize: 14,
            color: '#333',
            marginBottom: 0,
            '&>span:first-child':{
              height: '40px',
            }
        }
      },
      searchBarChips:{
        height: 'auto',
        '&>div:nth-of-type(1)':{
          border: "1px solid #dfdfdf",
          borderRadius: 4,
          padding: '0 0 0 15px',
          '&>div:nth-of-type(1)':{
            '&>div:nth-of-type(1)':{
              '&>div:nth-of-type(1)':{
                '&>div:nth-of-type(1)':{
                  overflow: 'initial',
                  '&>div:last-of-type':{
                    marginTop: 'initial !important',
                    lineHeight: '30px',
                  }
                }
              }
            }
          }
        },
        '& svg':{
          cursor: 'pointer'
        }
      },
    //   Switch style
      swithMain:{
        marginBottom: 10,
      },
      switchBar:{
        height: 24,
        marginTop: '-12px',
        width: 46,
        borderRadius: 20,
        marginLeft: '-16px',
        backgroundColor: '#fff',
        border: '1px solid #DFDFDF ',             
        opacity: 1

      },
      IscheckedSwitch:{
        opacity: 1,
        marginRight: '-21px',
        color: '#1d7dea!important',
        marginLeft: '0px!important'
      },
      checkedSwitch:{        
        color: '#D8D8D8', 
        marginRight: '-17px',  
        opacity: 1,   
        // height: 30,
        '& + $switchBar': {
          opacity: 1,
          backgroundColor: '#fff!important',
          border: '1px solid #DFDFDF',          
        },
      },
      switchIcon:{
        // backgroundColor: '#fff'
        color: '#D8D8D8',
        marginLeft:8,
      },

      // Create course popup
      colorPrimary:{
        color: '#1D7DEA'
      },
      colorYellow:{
        color: '#FBAB4C'
      },
      colorRed:{
        color: '#D9505D'
      },
      title:{
        fontWeight: 600,
        fontSize: 18,
        lineHeight: '14px'
      },
      description:{
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '22px',
        color: '#666',
        marginTop: 8,
        textAlign: 'justify'
      },
      borderB:{
        borderBottom: '1px solid #999',
      },
      minus15T:{
        marginTop: '-15px',
        marginBottom: '-15px'
      },
      font24:{
        fontSize: 24,
        fontWeight: 600,
      },
      textCenter:{
        textAlign: 'center',
        cursor: 'pointer'
      },
      ptb15:{
        padding: '15px 0', 
      },
      pb15:{
        paddingBottom: '15px', 
      },
      // Advance Setting (General Setting)
      height100VH:{
        height: '100vh'
      },
      overflowAuto: {
        overflowY: 'auto'
      },
      cardPadding:{
        padding: '10px 20px 15px 20px',
        '& input':{
          height: '36px'
        }
      },
      paddingBottom85: {
        paddingBottom: '85px',
      },
      '.AddRow':{
        '&>:nth-of-type(2)':{    
            marginTop: 10,
          },
      },
      activeElement:{
        fontSize: 14,
        fontWeight: 600,
        color: '#1d7dea',
      },
      inActiveElement:{
        '& p':{
          fontSize: 14,
          color: '#666',
          '$.borderBottom &':{
            fontSize: 14,
            fontWeight: 600,
            color: '#1d7dea',
            borderColor: '#1d7dea'
          }
        },
      },
      switchCustom:{
        '&>:first-child':{
          '&>:first-child':{
            marginLeft: 0,
            '&>:nth-child(2)':{
              fontSize: 16,
              fontWeight: 600
            }
          }
        }
      },
      switchCustom2:{
        '&>:first-child':{
          '&>:first-child':{
            '&>:nth-child(2)':{
              fontSize: 16,
              fontWeight: 600
            }
          }
        }
    },
    labelTxt:{
      fontSize: '16px!important',
      color: '#666!important',
      fontWeight: 600,
      '& span':{
        color: '#F93535'
      }
    },
    labelNormal:{
      fontSize: '16px!important',
      color: '#666!important',
      fontWeight: 400
    },
    mr27:{
      marginRight: 27,
    },
    checked: {},
    courseRadioGroup:{
      '&$checked': {
        '&, & + $label': {
          color: 'blue',
        },
      },
      '& label':{
        '&>:nth-child(2)':{
          fontSize: 16,
          fontWeight: 400,
          color: '#666'
        }
      }
    },
    mb15:{
      marginBottom: 15
    },
    countryFlag:{
      position: 'absolute',
      zIndex: 9,
      padding: '0 8px',
      '&>:first-child':{
        '&>:first-child':{
          '&>:first-child':{
            '&>:first-child':{
              display: 'flex',
              alignItems: 'center',
              borderRight: '1px solid #ddd',
              // height: '25px',
              paddingTop: 8,
              '&:hover':{
                background: 'transparent'
              }
            }
          }
        }
      }
    },
    AddPriceCTA:{
      '& span':{
        color: '#1d7dea',
        fontSize: 16,
        fontWeight: 600,
        display: 'inline-block',
        textAlign: 'right',
        padding: '10px 0',
        cursor: 'pointer',
      }      
    },
    posRelative:{
      position: 'relative',
    },
    DeleteCTA:{
      position: 'absolute',
      right: '-22px',
      top: 17,
      cursor: 'pointer',
    },
    DeleteFAQ:{
      top: 0,
      right: 0,
      '& img':{
        filter: 'grayscale(1)'
      }
    },
    coursePrice:{
      '& input':{
        paddingLeft: 80,
        height: '36px'
      }
    },
    coursePriceJustIndia:{
      '& input':{
        paddingLeft: 16,
        height: '36px'
      }
    },
    // SEO
    mb13:{
      marginBottom: 13,
      color: '#333'
    },
    red:{
      backgroundColor: '#cc0000'
    },
    customTextArea:{
      '&>:first-child':{
        '&>:first-child':{
          marginTop: 0,
          borderRadius: 4,
          '& textarea':{
            width: '97%',
            boxSizing: 'initial',
          }
        }
      }
    },
    // FAQ
    mb18:{
      marginBottom: 18,
    },
    mb8:{
      marginBottom: 8,
    },
    linkCTA:{
      color: '#1d7dea',
      fontSize: 16,
      fontWeight: 600,
      cursor: 'pointer'
    },
    disableCTA:{
      color: 'lightGray',
      fontSize: 16,
      fontWeight: 600,
      cursor: 'default',
      '& > img':{
        filter: "grayscale(1)",
        opacity: .3,
      }
    },
    customFileBrowse:{
      verticalAlign: "revert",
      marginRight:35,
      marginTop:-6,
      display: "inline-block",
      '& [type=file]': {
        height:0,
        overflow: "hidden",
        width:0,
      }
    },
    // calendar
    customCalendar:{
      '& .rdrCalendarWrapper':{
        width: 'auto'
      },
      '& input':{
        paddingRight: 0
      }
    },
    // Add Edit Schedule test
    manageField:{
      display: 'flex',
      justifyContent: 'space-between',
      // alignItems: "center",
      whiteSpace: "nowrap",
      // '&>:first-child':{
      //   marginRight: 15,
      // },
      // '&>:nth-child(2)':{
      //   marginRight: 15,
      // },
    },
    customTime:{
      marginTop:15,
      marginBottom:15,
      '& input':{
        border: "1px solid #DFDFDF",
        borderRadius:4,
        height: '36px',
        padding: '0 15px',
        color: '#333',
        fontSize: 16,
        '&::placeholder':{
          color: "#999",
          fontWeight: 'normal',
          fontSize:14,
          opacity: 1,
          fontFamily: '"Nunito", sans-serif',
        },
        '&:hover':{
          cursor: 'pointer',
        },
      },
      '&>:first-child':{
        width: '100%',
        '&::before':{
          borderBottom: 0,
        },
        '&::hover':{
          borderBottom: 0,
        },
        '&::placeholder':{
          color: "#999",
          fontWeight: 'normal',
          fontSize:14,
          opacity: 1,
          fontFamily: '"Nunito", sans-serif',
        },
      },
      
    },
    customTextField: {
      '&>:first-child':{
        marginTop: 0,
        width: '100%'
      },
      '& input': {
          padding: '3px 0px 2px 6px',
          width: '100%',
          height: 30,
          background: 'rgb(255 255 255)',
          // border: '1px solid rgb(223 223 223)',
          borderRadius: 4
      },
      "& input::-webkit-clear-button, & input::-moz-clear-button, & input::-webkit-outer-spin-button, & input::-moz-outer-spin-button, & input::-webkit-inner-spin-button & input::-moz-inner-spin-button": {
          display: "block",
          height: 35,
          width: 18,
          padding: '0px 4px'
      },
      "& input[type=number]::-webkit-inner-spin-button, & input[type='number'].mod::-moz-inner-spin-button, & input[type=number]::-webkit-outer-spin-button, & input[type='number'].mod::-moz-outer-spin-button": {
          opacity: 1
      },
      "& input[type=number]":{
          '-moz-appearance': 'textfield'
      },
      '&>div:nth-of-type(1)':{
        '&>div:nth-of-type(1)':{
          height: 38,
        }
      }
    },
    customSelect: {
      marginBottom: 8,
      "& > div:nth-of-type(1)": {
        display: "flex",
        borderRight: "1px solid #DFDFDF",
        height: '38px',
        padding: 0,
      },
    },
    testRadioGroup:{
      width: '100%',
      display: 'inline-block',
      textAlign: 'center',
      '& $label':{
        '&>:nth-child(2)':{
          fontSize: 16,
          fontWeight: 400,
          color: '#333'
        }
      }
    },
    customInput:{
      display: 'initial!important',
      // marginTop: 10,
      position: 'relative',
      '&>:nth-child(2)':{
          marginTop: 0,
          // marginBottom: 0,
          width: '100%',
          '&>:first-child':{
            height: 44,
        }
      },
      '&>:nth-of-type(3)':{
        '&>div:nth-of-type()1':{
          marginBottom: 0,
        }
      },
      '&>:nth-of-type(4)':{
        '&>div:nth-of-type()1':{
          marginBottom: 0,
        }
      },
      '&>span':{
        position: "absolute",
        right: 15,
        top: 52,
        color: "#999",
        zIndex: 1,
      }
    },
    mt15:{
      marginTop: 15,
    },
    mt10:{
      marginTop: 10,
    },
    // Basic Info
    customDialogHeader:{
      "&>:first-child":{
        boxShadow: 'none',
        borderBottom: 'none',
        paddingBottom: 0,
        '& p':{
          paddingLeft: 0,
        }
      }
    },
    basicInfoHeading:{
      fontWeight: "bold",
      fontSize:20,
      lineHeight:'27px',
      color: '#333',
      marginBottom: 13,
    },
    basicInfoText:{
      fontWeight: "normal",
      fontSize:16,
      lineHeight:'20px',
      color: '#333',
      marginBottom: 20,
    },
    // Add test popup
    root:{
      '&>:first-child':{
        '&>:first-child':{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: "nowrap",
            flexDirection: "initial",
            // marginBottom: 15,
        }
      },
      '& $label':{
        '&>:nth-child(2)':{
            fontSize: 15,
            fontWeight: 400,
            color: '#333',
            marginLeft: '-4px',
            marginTop: 2,
        }
      }
    },

    courseTitle:{
      fontSize:24,
      textAlign: "center",
      fontWeight:600,
      lineHeight:'32px',
      paddingLeft:18,
    },
    mb30:{
      marginBottom: 30,
    },
    paddingB100:{
      paddingBottom: 100,
    },
    dialogCustomSelect: {
      '&>div:nth-of-type(1)':{
        minWidth: '100% !important',
      },
    },
    dialogCustomInput:{
      '&>div:nth-of-type(1)':{
        marginTop: 0,
      }
    },
    titleCapital:{
      textTransform: 'capitalize',
      marginBottom: 5,
    },
    disabledSwitch: {
      cursor: 'default',
      pointerEvents: 'none',
      opacity: .5
    },
    comboModal:{
      overflow: "auto",
      maxHeight: "calc(100vh - 75px)",
    },
    comboDialogHeader:{
      position: "fixed",
      width: "100%",
      zIndex: 2,
      left: 0,
    },
    transitionCSS: {
      position: 'relative',
      // "&>:last-of-type": {
        "& .searchTransition": {
          '&>span':{
            position: 'absolute',
            right: 0,
            top: '-32px',
          },
          "& .optionContainer": {
            left: 0,
            width: "100%",
            bottom: 64,
          },
          "&>:nth-child(2)": {
            "&:after": {
              top: -73,
              transform: "rotate(44deg)!important",
            },
          },
        },
        "& .calenderTransition": {
          "&>:first-child": {
            width: '100%!important',
            "& .rdrCalendarWrapper": {
              border: "1px solid #ddd",
              boxShadow: "1px 1px 1px #ddd",
              background: "#fff",
              borderRadius: 4,
              bottom: "46px!important",
              top: "initial!important",
            },
          },
        },
      // },
    },
    inputCont:{
      '&>div:nth-of-type(1)':{
        width: '100%',
        '&> div':{
          '& input':{
            paddingLeft: 30,
          }
        }
      }
    },
    dialogSelect:{
      '&>div:nth-of-type(1)':{
        width: '100%',
      }
    },
    basicTitle:{
      fontSize:16,
      fontWeight:400,
    },
    customGrid:{
      display: "grid",
      gridTemplateColumns: "50% 50%",
      '& > div':{
        flexBasis: '100%',
        maxWidth: '100%',
        '&:nth-of-type(1)':{
          marginRight: 10,
        },
        '&:nth-of-type(3)':{
          marginRight: 10,
        }
      }
    },
    mb30Custom:{
      marginBottom: 30,
      '&>div:nth-of-type(1)':{
        width: '100%',
      }
    },
    paddingTop0:{
      paddingTop: '0 !important',
    },
    paddingBot0:{
      paddingBottom: '0 !important',
    },
    updatedLabel:{
      backgroundColor: '#F4F4F4',
      margin: 0,
      padding: '0 10px',
      borderRadius: 4,
      '&>span':{
        '&>span:nth-of-type(1)':{
          height: 40,
        }
      }
    },
    errorText: {
      color: theme.palette.error.light,
      verticalAlign: "middle",
      marginTop: "3px",
      "& svg": {
        verticalAlign: "bottom",
      },
    },
    radioContainer:{
      display: 'grid',
      gridTemplateColumns: '50% 50%',
      '& button':{
        gridColumn: 'span 2',
        maxWidth: 150,
        width: '100%',
        margin: '30px auto',
        marginottom: 5,
      },
      '& label':{
        marginRight: 10,
        justifyContent: 'space-between',
        maxWidth: 150,
        width: '100%',
      }
    },
    removeEndDate: {
      position: 'absolute',
      right: 18,
      marginTop: 7,
      textDecoration: 'none',
      color: '#1D7DEA',
      fontSize: 14,
      fontWeight: 600,
      backgroundColor: 'transparent',
      border: 'none',
      cursor: 'pointer',
      '&:disabled': {
        opacity: 0.5,
        cursor: 'default',
      }
    },
    tabBorder:{
      padding: '0px',
      marginTop: '-20px'
    },
    mt_0:{
      marginTop: 0,
    },
    customTabs: {
      width: '100%',
      backgroundColor: '#fff',      
      '& ul': {
        paddingLeft: 0,
        display: 'flex', 
        listStyle: 'none',
        '& li': {
          fontSize: 14,
          color: "#666",
          padding: "0 15px",
          cursor: 'pointer'
        }
      }
    },
    subTabs: {
      fontSize: 14,
      fontWeight: 400,
      color: '#666',
      cursor: 'pointer',
    },
    activeTab: {
      color: '#1d7dea!important',
      position: 'relative',
      fontWeight: 600,
      cursor: 'pointer',
      '&::before': {
        content: "''",
        width: '100%',
        height: 4,
        display: 'inline-block',
        position: 'absolute',
        left: 0,
        right: 0,
        top: 24,
        background: '#1d7dea',
        borderRadius: 4,
      }
    },
    logsCta:{
      fontSize:14,
      fontWeight:600,
      color: "#1d7dea",
      cursor: 'pointer',
      marginTop: '20px',
      marginRight: '20px',
      display: 'inline-block',
      '&:hover':{
        textDecoration: 'none',
      },
      '& img':{
        verticalAlign: '-7px',
      }
    },
    textRight:{
      textAlign: 'right'
    },
    padding0:{
      padding: 0
    },
    headerSection:{
      padding: '15px 20px 20px 20px'
    },
    chapterList:{
      borderTop: 'solid 1px #e6e6e6',
      padding: '15px 30px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      '&:last-child':{
        borderBottom: 'solid 1px #e6e6e6',
      },
    },
    phasePlanCta:{
      cursor: 'pointer',
      fontSize: 14,
      fontWeight: 700,
      color: '#1d7dea',
      textTransform: 'uppercase',
      '&:hover':{
        textDecoration: 'none',
      }
    },
    hourCount:{
      fontSize: 14,
      fontWeight: 400,
      color: '#666',
      '& input':{
        border: 'solid 1px rgba(223, 223, 223, 1)',
        borderRadius: 4,
        width: 70,
        height: 36,
        padding: 12,
        '&:focus-visible':{
          borderColor: 'rgba(223, 223, 223, 1)',
        },
        '&:focus':{
          outline: 'none'
        }
      }
    },
    chapterHeader:{
      fontSize: 20,
      fontWeight: 400,
      color: '#333',  
      flex: 1,    
    },
    phasedate:{
      fontStyle: 'normal',
      fontSize: 16,
      fontWeight: 400,
      color: '#666',
      '&::before':{
        content: '"•"',
        margin: '0 10px',
        display: 'inline-block',
        color: '#C4C4C4'
      }
    },
    listItem:{
      fontSize: 18,
      fontWeight: 400,
      color:'#333',
      width: '50%',
      '& span':{
        fontSize: 14,
        color: '#666',
        fontWeight: 400
      }
    },
    strip:{
      background: '#FFC2011A',
      padding: '15px 20px',
      fontSize: 16,
      fontWeight: 400,
      color: '#666',
      borderRadius: '4px 4px 0 0'
    },
    uploadedFile:{
      border: 'solid 1px #e6e6e6',
      padding: '12px 10px',
      borderRadius: 4,
      display: 'inline-flex',
      alignItems: 'center',
      '& span':{
        fontSize: 12,
        fontWeight: 400,
        color: 'rgba(51, 51, 51, 1)',
        margin: '0 18px 0 5px'
      }
    },
    uploadBtn:{
      background: 'rgba(29, 125, 234, 0.1)',
      border: 'dashed 1px rgba(230, 230, 230, 1)',
      borderRadius: 4,
      padding: '14px 43px',
      fontSize: 12,
      fontWeight: 600,
      color: 'rgba(29, 125, 234, 1)',
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      position: 'relative',
      '& img':{
        marginRight: 10,
      },
      '& input[type="file"]':{
        opacity:0,
        position: "absolute",
        right:0,
        width:'100%',
        height: '100%',
        zIndex:2,
        cursor: 'pointer',
        top: 0,
        fontSize: 0,
      }
    },
    cursorPointer:{
      cursor: 'pointer',
    },
    // Course Logs
    textSM: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '16px',
      color: 'rgba(51, 51, 51, 1)'
    },
    tableRowFont: {
      color: '#666666',
      fontSize: 16,
      lineHeight: '16px'
    },
    table: {
      minWidth: 500,
      '& td': {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
      },        
    },
    tableWrapper: {
      overflowX: 'auto',
      background: '#FFFFFF',
      boxSizing: 'border-box',
      borderRadius: 4
    },
    tableHead: {
      boxSizing: 'border-box',
      borderRadius: '4px 4px 0px 0px',
      height: 75
    },
    tableCell: {
      maxWidth: 130,
      padding: '18px 20px',
      border: 'none',
    },
    tableRow: {
      '& td': {
          fontSize: 16,
          lineHeight: '16px',
          color: 'rgba(51, 51, 51, 1)',
          '&:nth-child(4)': {
              color: '#333333'
          }, 
          '&:nth-child(1)': {
              color: '#333333'
          }, 
      },            
      '&:nth-of-type(even)': {
          backgroundColor: 'rgba(248, 248, 248, 1)',
      }
    },
    // Hour Allocation
    customUpload:{
      border: 'dashed 1px #e6e6e6',
      background: '#F7F5F5',
      marginBottom: 10,
      fontSize: 12,
      fontWeight: 400,
      color: '#666',
      padding: 25,
      position: 'relative',
      cursor: 'pointer',
      textAlign: 'center',
      '& input':{
        opacity:0,
        position: "absolute",
        width: "100%",
        height: "100%",
        left:0,
        top:0,
        cursor: 'pointer',
      },
      '& img':{
        width: 16,
        marginRight: 10,
      },
    },
    downloadCta:{
      color: '#1d7dea',
      fontSize: 12,
      fontWeight: 400,
      textAlign: 'right',
      cursor: 'pointer',
      '&:focus':{
        textDecoration: 'none',
      }
    },
    assignHours:{
      '& .perfectScrollBar':{
        paddingBottom: 0
      },
    },
    customHeader:{
      position: 'relative',
    },
    dialogTitle:{
      fontSize: 24,
      fontWeight: 600,
      color: '#333',
    },
    dialogClose:{
      top:0,
      right: "-30%",
      cursor: "pointer",
      position: "absolute",
    },
    closeBtn:{
      padding:8,
      minWidth: "auto",
      "&:hover":{
        background: 'transparent',
      },
      "& img":{
        margin: 0,
      }
    },
    excelIcon:{
      verticalAlign: "sub",
      marginRight: "6px!important",
    }
});

const useStyles = () => createStyles({

});

export { styles}
